import { createAction, props } from '@ngrx/store';
export const deleteAllNotifications = createAction('[Notifications Modal] Delete All Notifications');
export const setFetchNotificationsSuccess = createAction('[Notifications Modal] Fetch Notifications Success', props());
